import { useRouter } from "@edreamsodigeo/frontend-core";

import { isDynpackFromUrl } from "~/tools/funnelUtils";

const ACCOMMODATION_PATH = ["hotel_payment", "hotel_prime", "hotel_checkout"];

const DYNPACK_PATH = ["dynpack_"];

interface UseFunnelFromUrlResult {
  isHSAFunnel: boolean;
  isDynpackFunnel: boolean;
}

const useHasRouterPathname = (funnelPathNames: string[]): boolean => {
  const { pathname } = useRouter();

  return funnelPathNames.some((path) => pathname.includes(path));
};

export const useFunnelFromUrl = (): UseFunnelFromUrlResult => {
  const isHSAFunnel = useHasRouterPathname(ACCOMMODATION_PATH);
  const isDynpackFromRouterPathname = useHasRouterPathname(DYNPACK_PATH);
  const isDynpackFunnel = isDynpackFromUrl() || isDynpackFromRouterPathname;

  return {
    isHSAFunnel: isHSAFunnel,
    isDynpackFunnel: isDynpackFunnel,
  };
};
